// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2IWfJ","bigColWidth":"Table_bigColWidth__16g1A","biggerColWidth":"Table_biggerColWidth__16y1H","row":"Table_row__21_-W","col":"Table_col__3mbAL"};